import { UI, HStack, VStack } from '@genial/components';
import { Color, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import { Box } from 'native-base';
import React from 'react';

export interface TimeLineItemProps {
  label: string;
  formattedDate: string;
  date: Date;
}

export const TimeLineItem: React.FC<TimeLineItemProps> = ({ label, formattedDate, date }) => {
  const isFutureDate = Utils.Date.IsFuture(date);

  const isReservationDate = label === 'Limite para Reserva';

  const getTextColor = () => {
    if (isFutureDate) {
      return Color['neutral.dark'];
    }
    if (isReservationDate) {
      return Color['feedback.error.default'];
    }
    return Color['neutral.darkest'];
  };

  const getBoxBorderColor = () => {
    if (isFutureDate) {
      return Color['neutral.dark'];
    }
    if (isReservationDate) {
      return Color['feedback.error.default'];
    }
    return Color['brand.primary.principal'];
  };

  const getBoxBackgroundColor = () => {
    if (isFutureDate || isReservationDate) {
      return Utils.ColorToken.WithOpacity('background', 'opacity.semitransparent');
    }
    return Color['brand.primary.principal'];
  };

  const getBoxProps = () => {
    return {
      bg: getBoxBackgroundColor(),
      borderRadius: 'full',
      borderWidth: 1,
      borderColor: getBoxBorderColor(),
    };
  };

  return (
    <HStack space="inline.xxxs" alignItems="center">
      <Box w="8px" h="8px" {...getBoxProps()} />
      <VStack space="stack.quarck">
        <UI.Text variant="semibold" fontSize={Typography['fontsize.xs']} color={getTextColor()}>
          {label}
        </UI.Text>
        <UI.Text variant="regular" color={getTextColor()}>
          {formattedDate}
        </UI.Text>
      </VStack>
    </HStack>
  );
};
